import { render, staticRenderFns } from "./goodsImgRs.vue?vue&type=template&id=dc1ff0ea&scoped=true&"
import script from "./goodsImgRs.vue?vue&type=script&lang=js&"
export * from "./goodsImgRs.vue?vue&type=script&lang=js&"
import style0 from "./goodsImgRs.vue?vue&type=style&index=0&id=dc1ff0ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1ff0ea",
  null
  
)

component.options.__file = "goodsImgRs.vue"
export default component.exports